import { Component } from '@angular/core';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { readOnlyReselector } from 'src/app/store/reselectors/permissions.reselector';
import { pageGroupHandles } from 'globals/store/permissions.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { JoiEvent } from 'globals/store/events.data';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { EnableLinksComponent } from '../logistics/enable-links-component';
import { InformableComponent } from 'src/app/components/informable/informable.component';
import { CommonModule } from '@angular/common';
import { traceNames } from 'src/app/services/performance.tracking.data';


@Component({
    selector: 'app-event-information',
    templateUrl: './event-information.page.html',
    styleUrls: ['./event-information.page.scss', '../../page.scss'],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, MobileMenuComponent, IconComponent, BinaryShareToggle, EnableLinksComponent, InformableComponent, CommonModule ],
})
export class EventInformationPageComponent extends Wrapper<EventInformationPageComponent> {

  page_name = PAGE_NAME.event_information;
  groupHandle = pageGroupHandles.event_information
  traceNames = traceNames
  readonly = true
  event: JoiEvent

  constructor() {
    super()
    this.subProp(this.store.select(readOnlyReselector), 'readonly')
    this.uiService.changePageTitle("Event Information", true)
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  toggleEnableLinks() {
    this.eventService.updateEvent(this.event.eventId, { linksInEventInformation: !this.event.linksInEventInformation })
  }

  toggleShare() {
    this.eventService.updateEvent(this.event.eventId, { shareEventInformation: !this.event.shareEventInformation })
  }
}
